export default __webpack_public_path__ + "static/media/beta-top-up.d07f798c.png";